import { ATTACHMENT_VARIANTS } from "data/products/attachments";
import { Province } from "types/canvasTypes";

const extractVariantId = (gid: string | undefined) => {
  if (!gid) return "---";
  return gid.split("/").pop() || gid;
};

const attachmentEntries = Object.values(ATTACHMENT_VARIANTS);

const AdminAttachments = () => {
  return (
    <div>
      <div className="admin-page-header">
        <div className="admin-page-header__left">
          <h1>Attachments</h1>
          <span className="admin-badge">{attachmentEntries.length}</span>
        </div>
      </div>

      <div className="admin-table-wrap">
        <table className="quotation-table">
          <thead>
            <tr>
              <th>Attachment</th>
              <th>Silver QC</th>
              <th>Silver ON</th>
              <th>Black QC</th>
              <th>Black ON</th>
              <th>BC Silver</th>
              <th>BC Black</th>
              <th>GR Silver</th>
              <th>GR Black</th>
              <th>RF Silver</th>
              <th>RF Black</th>
            </tr>
          </thead>
          <tbody>
            {attachmentEntries.map((att) => (
              <tr key={att.material}>
                <td>
                  <strong>{att.material}</strong>
                </td>
                <td>${att.costSilver.get(Province.Quebec) ?? "---"}</td>
                <td>${att.costSilver.get(Province.Ontario) ?? "---"}</td>
                <td>${att.costBlack.get(Province.Quebec) ?? "---"}</td>
                <td>${att.costBlack.get(Province.Ontario) ?? "---"}</td>
                <td className="admin-cell-mono">
                  {extractVariantId(att.bcVariantSilverId)}
                </td>
                <td className="admin-cell-mono">
                  {extractVariantId(att.bcVariantBlackId)}
                </td>
                <td className="admin-cell-mono">
                  {extractVariantId(att.grVariantSilverId)}
                </td>
                <td className="admin-cell-mono">
                  {extractVariantId(att.grVariantBlackId)}
                </td>
                <td className="admin-cell-mono">
                  {extractVariantId(att.rfVariantSilverId)}
                </td>
                <td className="admin-cell-mono">
                  {extractVariantId(att.rfVariantBlackId)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminAttachments;
